import React, {useState} from "react"
import {FaMinus, FaPlus} from "react-icons/fa6";
import {sendToServer} from "../BidibDataProvider";
import c from "../etc/Const";
import {send_add_cmd} from "../etc/cmd";

const NewLc = () => {

    const [addr, setAddr] = useState("");

    function newLc(id) {
        let co = {};
        co.id = id;
        co.type = 'lc'
        co.typename = 'item'

        if( id !== "") {
            send_add_cmd(co)
        }

        setAddr("")
    }

    return (
        <div
            className='unit lc'
            style={{
                padding: '5px',
                margin: '5px',
                border: '1px solid black',
                width: 'auto',
                alignItems: 'center',
                justifyContent: 'center',
                fontFamily: 'monospace',
                cursor: 'default',
            }}>

            <input
                style={{
                    width: "80%",
                    background: "#dddddd",
                    border: "none",
                    fontSize: "11px",
                }}
                value={addr}
                onChange={(e) => setAddr(e.target.value)}></input>

            <div className="smallIcon"
                 onClick={() => newLc(addr)}>
                {<FaPlus scale={0.5}/>}
            </div>

        </div>
    )
}

export default NewLc